<template>
  <a-modal v-model:open="computedShowModal"
           width="566px"
           :closable="false"
           :footer="null"
           :mask-closable="false"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
  >
    <div class="modal-content-body">
      <div class="search-client-header">
        <div class="modal-title">
          계약 내용 확인
        </div>
        <button
            type="button"
            class="btn-close"
            @click="uiHandler.closeModal"
        >
          <i class="fa-regular fa-x"/>
        </button>
      </div>
      <div class="summary-container">
        <div class="desc-container" v-for="(value, key, index) in summaryContents" :key="index">
          <div class="label">
            <i class="fa-solid" :class="uiHandler.getSummaryContent(key)"></i>
            {{ key }}
          </div>
          <div class="text">
            <div v-if="key === '병원 연락처' || key === '병원명' || key === '업체 연락처' || key === '업체명'"
                 v-html="uiHandler.processValue(value)">
            </div>
            <div v-else-if="key === '총 계약 금액'">
              {{ Number(value).toLocaleString() }}
            </div>
            <div v-else-if="key === '월 렌탈 금액'">
              {{ `월 ${value}` }}
            </div>
            <div v-else-if="key === '약정 개월 수'">
              {{ value }}
            </div>
            <div v-else>
              {{ value }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="expiration-modal-footer" style="padding-top: 12px; border-top: 1px solid rgba(0,0,0,0.1)">
      <button
          class="contract-cancel-btn btn-hover"
          @click="uiHandler.closeModal"
      >
        취소
      </button>
      <button
          class="contract-submit-btn btn-hover"
          @click="uiHandler.emitClient"
      >
        확인 완료
      </button>
    </div>
  </a-modal>
</template>
<script>
import {EmitEvents} from "@/views/ContractManagement/contracts/dentium/EmitEvents";
import {logging} from "@/utils/utils";

export default {
  components: {},
  emits: Object.keys({...EmitEvents.SummaryModal, ...EmitEvents.Common}),
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false
    },
    summaryContents: {
      type: Object,
      default: () => ({}),
      validator: (item) => typeof item === 'object'
    }
  },
  data() {
    return {
      uiHandler: this.ui(),
    }
  },
  mounted() {
    logging().exceptProd("summary modal==>", this.summaryContents)
  },
  computed: {
    computedShowModal() {
      return this.showModal;
    },
  },
  methods: {
    ui() {
      return {
        emitClient: () => {
          this.$emit(EmitEvents.SummaryModal.SummaryConfirm, true);
        },
        closeModal: () => {
          this.$emit(EmitEvents.Common.CloseModal, false);
        },
        processValue(value) {
          let parts = value.split('/');
          for (let i = 0; i < parts.length; i++) {
            parts[i] = parts[i].replace(/\((.*?)\)/g, '<span style="color: #8D939A">$&</span>');
          }
          return parts.join('<br>');
        },
        getSummaryContent(key) {
          let iconClass = "";
          switch (key) {
            case "계약명":
              iconClass = "fa-tags";
              break;
            case "병원명":
              iconClass = "fa-hospital";
              break;
            case "업체명":
              iconClass = "fa-hospital";
              break;
            case "병원장명":
              iconClass = "fa-user-doctor";
              break;
            case "대표명":
              iconClass = "fa-user-doctor";
              break;
            case "병원 주소":
              iconClass = "fa-location-dot";
              break;
            case "업체 주소":
              iconClass = "fa-location-dot";
              break;
            case "공사 위치":
              iconClass = "fa-location-dot";
              break;
            case "병원 연락처":
              iconClass = "fa-phone";
              break;
            case "업체 연락처":
              iconClass = "fa-phone";
              break;
            case "총 계약 금액":
              iconClass = "fa-won-sign";
              break;
            case "월 렌탈 금액":
              iconClass = "fa-won-sign";
              break;
            case "약정 개월 수":
              iconClass = "fa-calendar";
              break;
            default:
              iconClass = "";
          }
          return iconClass;
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/search-client-modal.scss';
</style>
<style scoped>
.summary-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 16px 20px 16px 20px;

  .desc-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 16px;

    .label {
      min-width: 130px;
      color: #6E747C;
      font-size: 15px;
      margin-right: 20px;
    }

    .label i {
      margin-right: 8px;
    }
  }
}
</style>
